import { extractInteractionLevel } from "../utils/commonUtils";

export default class Case {
    case_id: string;
    customer_id: string;
    client_name: string;
    agency_name: string|undefined;
	pool_month: string;
	client_reference_id: string;
    agent_case_allocation_id?: string;
    username?: string;
	client_manager_username: string;
    loan_type: string;
    dpd_bucket: string;
    customer_name: string;
    customer_phone_number: string;
    assigned_agents: string[];
    total_due_amount: number;
    principal_outstanding_amount: number;
    eligible_settlement_amount: number|undefined;
    collected_amount: number;
    focused: boolean;
    expiry_date?: string;
    case_score?: number;
    is_active?: boolean;
    min_due_amount: number;
    best_interaction: string|undefined;
    best_sub_interaction: string|undefined;
    best_rest_interaction: string|undefined;
    best_ptp_date: string|undefined;
    best_followup_date: string|undefined;
    best_comment: string;
    best_interaction_date: string;
    best_interaction_mode: string;
    best_interaction_type: string;
    latest_interaction: string|undefined;
    latest_sub_interaction: string|undefined;
    latest_rest_interaction: string|undefined;
    latest_ptp_date: string|undefined;
    latest_followup_date: string|undefined;
    latest_comment: string;
    latest_interaction_date: string;
    latest_interaction_mode: string;
    latest_interaction_type: string;
    best_call_interaction: string|undefined;
    best_call_sub_interaction: string|undefined;
    best_call_rest_interaction: string|undefined;
    best_call_ptp_date: string|undefined;
    best_call_followup_date: string|undefined;
    best_call_comment: string;
    best_call_interaction_date: string;
    best_call_interaction_type: string;
    best_visit_interaction: string|undefined;
    best_visit_sub_interaction: string|undefined;
    best_visit_rest_interaction: string|undefined;
    best_visit_ptp_date: string|undefined;
    best_visit_followup_date: string|undefined;
    best_visit_comment: string;
    best_visit_interaction_date: string;
    best_visit_interaction_type: string;
    latest_call_interaction: string|undefined;
    latest_call_sub_interaction: string|undefined;
    latest_call_rest_interaction: string|undefined;
    latest_call_ptp_date: string|undefined;
    latest_call_followup_date: string|undefined;
    latest_call_comment: string;
    latest_call_interaction_date: string;
    latest_call_interaction_type: string;
    latest_visit_interaction: string|undefined;
    latest_visit_sub_interaction: string|undefined;
    latest_visit_rest_interaction: string|undefined;
    latest_visit_ptp_date: string|undefined;
    latest_visit_followup_date: string|undefined;
    latest_visit_comment: string;
    latest_visit_interaction_date: string;
    latest_visit_interaction_type: string;
    status: string;
    pin_code: string;
    area: string;
    state: string;
    district: string;
    created_date: string;
    updated_date: string;
    updated_by: string;

    constructor(
        case_id: string,
        customer_id: string,
        client_name: string,
        agency_name: string|undefined,
        pool_month: string,
        client_reference_id: string,
        client_manager_username: string,
        loan_type: string,
        dpd_bucket: string,
        customer_name: string,
        customer_phone_number: string,
        assigned_agents: string[],
        total_due_amount: number,
        principal_outstanding_amount: number,
        eligible_settlement_amount: number|undefined,
        collected_amount: number,
        focused: boolean,
        min_due_amount: number,
        best_interaction: string|undefined,
        best_sub_interaction: string|undefined,
        best_rest_interaction: string|undefined,
        best_ptp_date: string|undefined,
        best_followup_date: string|undefined,
        best_comment: string,
        best_interaction_date: string,
        best_interaction_mode: string,
        best_interaction_type: string,
        latest_interaction: string|undefined,
        latest_sub_interaction: string|undefined,
        latest_rest_interaction: string|undefined,
        latest_ptp_date: string|undefined,
        latest_followup_date: string|undefined,
        latest_comment: string,
        latest_interaction_date: string,
        latest_interaction_mode: string,
        latest_interaction_type: string,
        best_call_interaction: string|undefined,
        best_call_sub_interaction: string|undefined,
        best_call_rest_interaction: string|undefined,
        best_call_ptp_date: string|undefined,
        best_call_followup_date: string|undefined,
        best_call_comment: string,
        best_call_interaction_date: string,
        best_call_interaction_type: string,
        best_visit_interaction: string|undefined,
        best_visit_sub_interaction: string|undefined,
        best_visit_rest_interaction: string|undefined,
        best_visit_ptp_date: string|undefined,
        best_visit_followup_date: string|undefined,
        best_visit_comment: string,
        best_visit_interaction_date: string,
        best_visit_interaction_type: string,
        latest_call_interaction: string|undefined,
        latest_call_sub_interaction: string|undefined,
        latest_call_rest_interaction: string|undefined,
        latest_call_ptp_date: string|undefined,
        latest_call_followup_date: string|undefined,
        latest_call_comment: string,
        latest_call_interaction_date: string,
        latest_call_interaction_type: string,
        latest_visit_interaction: string|undefined,
        latest_visit_sub_interaction: string|undefined,
        latest_visit_rest_interaction: string|undefined,
        latest_visit_ptp_date: string|undefined,
        latest_visit_followup_date: string|undefined,
        latest_visit_comment: string,
        latest_visit_interaction_date: string,
        latest_visit_interaction_type: string,
        status: string,
        pin_code: string,
        area: string,
        state: string,
        district: string,
        created_date: string,
        updated_date: string,
        updated_by: string,
        agent_case_allocation_id?: string,
        username?: string,
        expiry_date?: string,
        case_score?: number,
        is_active?: boolean
    ) {
        this.case_id = case_id;
        this.customer_id = customer_id;
        this.client_name = client_name;
        this.agency_name = agency_name;
        this.pool_month = pool_month;
        this.client_reference_id = client_reference_id;
        this.client_manager_username = client_manager_username;
        this.loan_type = loan_type;
        this.dpd_bucket = dpd_bucket;
        this.customer_name = customer_name;
        this.customer_phone_number = customer_phone_number;
        this.assigned_agents = assigned_agents;
        this.total_due_amount = total_due_amount;
        this.principal_outstanding_amount = principal_outstanding_amount;
        this.eligible_settlement_amount = eligible_settlement_amount;
        this.collected_amount = collected_amount;
        this.focused = focused;
        this.min_due_amount = min_due_amount;
        this.best_interaction = best_interaction;
        this.best_sub_interaction = best_sub_interaction;
        this.best_rest_interaction = best_rest_interaction;
        this.best_ptp_date = best_ptp_date;
        this.best_followup_date = best_followup_date;
        this.best_comment = best_comment;
        this.best_interaction_date = best_interaction_date;
        this.best_interaction_mode = best_interaction_mode;
        this.best_interaction_type = best_interaction_type;
        this.latest_interaction = latest_interaction;
        this.latest_sub_interaction = latest_sub_interaction;
        this.latest_rest_interaction = latest_rest_interaction;
        this.latest_ptp_date = latest_ptp_date;
        this.latest_followup_date = latest_followup_date;
        this.latest_comment = latest_comment;
        this.latest_interaction_date = latest_interaction_date;
        this.latest_interaction_mode = latest_interaction_mode;
        this.latest_interaction_type = latest_interaction_type;
        this.best_call_interaction = best_call_interaction;
        this.best_call_sub_interaction = best_call_sub_interaction;
        this.best_call_rest_interaction = best_call_rest_interaction;
        this.best_call_ptp_date = best_call_ptp_date;
        this.best_call_followup_date = best_call_followup_date;
        this.best_call_comment = best_call_comment;
        this.best_call_interaction_date = best_call_interaction_date;
        this.best_call_interaction_type = best_call_interaction_type;
        this.best_visit_interaction = best_visit_interaction;
        this.best_visit_sub_interaction = best_visit_sub_interaction;
        this.best_visit_rest_interaction = best_visit_rest_interaction;
        this.best_visit_ptp_date = best_visit_ptp_date;
        this.best_visit_followup_date = best_visit_followup_date;
        this.best_visit_comment = best_visit_comment;
        this.best_visit_interaction_date = best_visit_interaction_date;
        this.best_visit_interaction_type = best_visit_interaction_type;
        this.latest_call_interaction = latest_call_interaction;
        this.latest_call_sub_interaction = latest_call_sub_interaction;
        this.latest_call_rest_interaction = latest_call_rest_interaction;
        this.latest_call_ptp_date = latest_call_ptp_date;
        this.latest_call_followup_date = latest_call_followup_date;
        this.latest_call_comment = latest_call_comment;
        this.latest_call_interaction_date = latest_call_interaction_date;
        this.latest_call_interaction_type = latest_call_interaction_type;
        this.latest_visit_interaction = latest_visit_interaction;
        this.latest_visit_sub_interaction = latest_visit_sub_interaction;
        this.latest_visit_rest_interaction = latest_visit_rest_interaction;
        this.latest_visit_ptp_date = latest_visit_ptp_date;
        this.latest_visit_followup_date = latest_visit_followup_date;
        this.latest_visit_comment = latest_visit_comment;
        this.latest_visit_interaction_date = latest_visit_interaction_date;
        this.latest_visit_interaction_type = latest_visit_interaction_type;
        this.status = status;
        this.pin_code = pin_code;
        this.area = area;
        this.state = state;
        this.district = district;
        this.created_date = created_date;
        this.updated_date = updated_date;
        this.updated_by = updated_by;
        this.agent_case_allocation_id = agent_case_allocation_id;
        this.username = username;
        this.expiry_date = expiry_date;
        this.case_score = case_score;
        this.is_active = is_active;
    }

    public static initialiseCase(responses: any): Case[] {
        let records: Case[] = [];
        for (const record of responses) {
            const caseRecord = new Case(
                record.case.case_id,
                record.case.customer_id,
                record.case.client_name,
                record.case.agency_name,
                record.case.pool_month,
                record.case.client_reference_id,
                record.case.client_manager_username,
                record.case.loan_type,
                record.case.dpd_bucket,
                record.case.customer_name,
                record.case.customer_phone_number,
                record.assigned_agents,
                record.case.total_due_amount,
                record.case.principal_outstanding_amount,
                record.case.eligible_settlement_amount,
                record.case.collected_amount,
                record.case.focused,
                record.case.min_due_amount,
                extractInteractionLevel(record.interaction_best?.disposition_order, 0, 1),
                extractInteractionLevel(record.interaction_best?.disposition_order, 1, 2),
                extractInteractionLevel(record.interaction_best?.disposition_order, 2),
                record.interaction_best?.ptp_date,
                record.interaction_best?.followup_date,
                record.interaction_best?.comment,
                record.interaction_best?.updated_date,
                record.interaction_best?.interaction_mode,
                record.interaction_best?.interaction_type,
                extractInteractionLevel(record.interaction_latest?.disposition_order, 0, 1),
                extractInteractionLevel(record.interaction_latest?.disposition_order, 1, 2),
                extractInteractionLevel(record.interaction_latest?.disposition_order, 2),
                record.interaction_latest?.ptp_date,
                record.interaction_latest?.followup_date,
                record.interaction_latest?.comment,
                record.interaction_latest?.updated_date,
                record.interaction_latest?.interaction_mode,
                record.interaction_latest?.interaction_type,
                extractInteractionLevel(record.interaction_best_call?.disposition_order, 0, 1),
                extractInteractionLevel(record.interaction_best_call?.disposition_order, 1, 2),
                extractInteractionLevel(record.interaction_best_call?.disposition_order, 2),
                record.interaction_best_call?.ptp_date,
                record.interaction_best_call?.followup_date,
                record.interaction_best_call?.comment,
                record.interaction_best_call?.updated_date,
                record.interaction_best_call?.interaction_type,
                extractInteractionLevel(record.interaction_best_visit?.disposition_order, 0, 1),
                extractInteractionLevel(record.interaction_best_visit?.disposition_order, 1, 2),
                extractInteractionLevel(record.interaction_best_visit?.disposition_order, 2),
                record.interaction_best_visit?.ptp_date,
                record.interaction_best_visit?.followup_date,
                record.interaction_best_visit?.comment,
                record.interaction_best_visit?.updated_date,
                record.interaction_best_visit?.interaction_type,
                extractInteractionLevel(record.interaction_latest_call?.disposition_order, 0, 1),
                extractInteractionLevel(record.interaction_latest_call?.disposition_order, 1, 2),
                extractInteractionLevel(record.interaction_latest_call?.disposition_order, 2),
                record.interaction_latest_call?.ptp_date,
                record.interaction_latest_call?.followup_date,
                record.interaction_latest_call?.comment,
                record.interaction_latest_call?.updated_date,
                record.interaction_latest_call?.interaction_type,
                extractInteractionLevel(record.interaction_latest_visit?.disposition_order, 0, 1),
                extractInteractionLevel(record.interaction_latest_visit?.disposition_order, 1, 2),
                extractInteractionLevel(record.interaction_latest_visit?.disposition_order, 2),
                record.interaction_latest_visit?.ptp_date,
                record.interaction_latest_visit?.followup_date,
                record.interaction_latest_visit?.comment,
                record.interaction_latest_visit?.updated_date,
                record.interaction_latest_visit?.interaction_type,
                record.case.status,
                record.pin_code.pin_code,
                record.pin_code.area_name,
                record.pin_code.state_name,
                record.pin_code.district,
                record.case.created_date,
                record.case.updated_date,
                record.case.updated_by,
                record.agent_case_allocation?.agent_case_allocation_id,
                record.agent_case_allocation?.username,
                record.agent_case_allocation?.expiry_date,
                record.agent_case_allocation?.case_score,
                record.agent_case_allocation?.is_active
            );
            records.push(caseRecord);
        }
        return records;
    }
}